<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="МФУ MX532, MX632, XM3350">
     МФУ MX532, MX632, XM3350
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ru" title="Информация по технике безопасности">
     Информация по технике безопасности
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Условные обозначения">
      Условные обозначения
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Заявление о продукте">
      Заявление о продукте
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ru" title="Подробнее о принтере">
     Подробнее о принтере
    </a>
   </p>
   <div id="divd0e175">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ru" title="Поиск информации о принтере">
      Поиск информации о принтере
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ru" title="Поиск серийного номера принтера">
      Поиск серийного номера принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ru" title="Конфигурации принтера">
      Конфигурации принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ru" title="Использование панели управления">
      Использование панели управления
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ru" title="Общие сведения о состоянии светового индикатора">
      Общие сведения о состоянии светового индикатора
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e500" title="Выбор бумаги">
      Выбор бумаги
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ru" title="Настройка и установка">
     Настройка и установка
    </a>
   </p>
   <div id="divd0e1569">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_ru" title="Выбор местоположения принтера">
      Выбор местоположения принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ru" title="Подключение кабелей">
      Подключение кабелей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e1764" title="Настройка и использование приложений начального экрана">
      Настройка и использование приложений начального экрана
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e2411" title="Настройка и использование функций специальных возможностей">
      Настройка и использование функций специальных возможностей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e2717" title="Настройка передачи факсов на принтере">
      Настройка передачи факсов на принтере
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_ru" title="Настройка параметров SMTP электронной почты">
      Настройка параметров SMTP электронной почты
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e4576" title="Загрузка бумаги и специальных материалов для печати">
      Загрузка бумаги и специальных материалов для печати
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e4742" title="Установка и обновление программного обеспечения, драйверов и микропрограммного обеспечения">
      Установка и обновление программного обеспечения, драйверов и микропрограммного обеспечения
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e5023" title="Установка дополнительных аппаратных модулей">
      Установка дополнительных аппаратных модулей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="wireless-support-topic.html#d0e5332" title="Сеть">
      Сеть
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ru" title="Обеспечение безопасности принтера">
     Обеспечение безопасности принтера
    </a>
   </p>
   <div id="divd0e5757">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ru" title="Расположение гнезда замка безопасности">
      Расположение гнезда замка безопасности
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ru" title="Удаление данных из памяти принтера">
      Удаление данных из памяти принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ru" title="Удаление данных с накопителя принтера">
      Удаление данных с накопителя принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ru" title="Восстановление значений по умолчанию, заданных изготовителем">
      Восстановление значений по умолчанию, заданных изготовителем
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ru" title="Заявление об энергозависимости">
      Заявление об энергозависимости
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ru" title="Печать">
     Печать
    </a>
   </p>
   <div id="divd0e5950">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ru" title="Печать с компьютера">
      Печать с компьютера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e5976" title="Печать с мобильного устройства">
      Печать с мобильного устройства
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ru" title="Печать с флеш-накопителя">
      Печать с флеш-накопителя
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_ru" title="Поддерживаемые флеш-накопители и типы файлов">
      Поддерживаемые флеш-накопители и типы файлов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ru" title="Настройка конфиденциальных заданий">
      Настройка конфиденциальных заданий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ru" title="Печать конфиденциальных и других отложенных заданий">
      Печать конфиденциальных и других отложенных заданий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_ru" title="Печать списка образцов шрифтов">
      Печать списка образцов шрифтов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_ru" title="Печать списка каталогов">
      Печать списка каталогов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_ru" title="Добавление страниц-разделителей между копиями">
      Добавление страниц-разделителей между копиями
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ru" title="Отмена задания на печать">
      Отмена задания на печать
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ru" title="Регулировка плотности тонера">
      Регулировка плотности тонера
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_ru" title="Копирование">
     Копирование
    </a>
   </p>
   <div id="divd0e6566">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ru" title="Использование устройства автоматической подачи документов и стекла сканера">
      Использование устройства автоматической подачи документов и стекла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_ru" title="Выполнение копирования">
      Выполнение копирования
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_ru" title="Копирование фотографий">
      Копирование фотографий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_ru" title="Копирование на бланке">
      Копирование на бланке
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ru" title="Копирование на обеих сторонах листа">
      Копирование на обеих сторонах листа
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_ru" title="Уменьшение и увеличение копий">
      Уменьшение и увеличение копий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_ru" title="Разбор по копиям">
      Разбор по копиям
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_ru" title="Добавление страниц-разделителей между копиями">
      Добавление страниц-разделителей между копиями
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_ru" title="Копирование нескольких страниц на один лист">
      Копирование нескольких страниц на один лист
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_ru" title="Копирование карточек">
      Копирование карточек
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_ru" title="Создание кода быстрого доступа копирования">
      Создание кода быстрого доступа копирования
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_ru" title="Электронная почта">
     Электронная почта
    </a>
   </p>
   <div id="divd0e6877">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_ru" title="Использование устройства автоматической подачи документов и стекла сканера">
      Использование устройства автоматической подачи документов и стекла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_ru" title="Отправка сообщения электронной почты">
      Отправка сообщения электронной почты
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_ru" title="Создание кода быстрого доступа для электронной почты">
      Создание кода быстрого доступа для электронной почты
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_ru" title="Факс">
     Факс
    </a>
   </p>
   <div id="divd0e6971">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_ru" title="Использование устройства автоматической подачи документов и стекла сканера">
      Использование устройства автоматической подачи документов и стекла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_ru" title="Отправка факса">
      Отправка факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_ru" title="Планирование задания факса">
      Планирование задания факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ru" title="Создание ярлыка места назначения факса">
      Создание ярлыка места назначения факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_ru" title="Изменение разрешения факса">
      Изменение разрешения факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ru" title="Настройка плотности факса">
      Настройка плотности факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_ru" title="Печать журнала факсов">
      Печать журнала факсов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_ru" title="Блокировка нежелательных факсов">
      Блокировка нежелательных факсов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_ru" title="Откладывание факсов">
      Откладывание факсов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_ru" title="Пересылка факса">
      Пересылка факса
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_ru" title="Сканирование">
     Сканирование
    </a>
   </p>
   <div id="divd0e7336">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_ru" title="Использование устройства автоматической подачи документов и стекла сканера">
      Использование устройства автоматической подачи документов и стекла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_ru" title="Сканирование на компьютер">
      Сканирование на компьютер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_ru" title="Сканирование на сервер FTP">
      Сканирование на сервер FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_ru" title="Создание кода быстрого доступа для FTP">
      Создание кода быстрого доступа для FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_ru" title="Сканирование в сетевую папку">
      Сканирование в сетевую папку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_ru" title="Создание кода быстрого доступа сетевой папки">
      Создание кода быстрого доступа сетевой папки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ru" title="Сканирование на флеш-накопитель">
      Сканирование на флеш-накопитель
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ru" title="Использование меню принтера">
     Использование меню принтера
    </a>
   </p>
   <div id="divd0e7639">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menu-map-mfp_ru" title="Карта меню">
      Карта меню
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e8020" title="Устройство">
      Устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e10354" title="Печать">
      Печать
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e11517" title="Бумага">
      Бумага
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e11877" title="Копирование">
      Копирование
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e12450" title="Факс">
      Факс
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e14878" title="Электронная почта">
      Электронная почта
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e15894" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e16540" title="USB-накопитель">
      USB-накопитель
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e17341" title="Сеть/Порты">
      Сеть/Порты
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e19485" title="Безопасность">
      Безопасность
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e20635" title="Облачные сервисы">
      Облачные сервисы
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e20692" title="Отчеты">
      Отчеты
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ru" title="Поиск и устранение неисправностей">
      Поиск и устранение неисправностей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_ru" title="Forms Merge">
      Forms Merge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_ru" title="Печать Страницы настроек меню">
      Печать Страницы настроек меню
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ru" title="Обслуживание принтера">
     Обслуживание принтера
    </a>
   </p>
   <div id="divd0e21236">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_ru" title="Проверка состояния компонентов и расходных материалов">
      Проверка состояния компонентов и расходных материалов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ru" title="Настройка уведомлений о расходных материалах">
      Настройка уведомлений о расходных материалах
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_ru" title="Настройка уведомлений по электронной почте">
      Настройка уведомлений по электронной почте
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_ru" title="Просмотр отчетов">
      Просмотр отчетов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_ru" title="Заказ компонентов и расходных материалов">
      Заказ компонентов и расходных материалов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e21569" title="Замена компонентов и расходных материалов">
      Замена компонентов и расходных материалов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e21912" title="Очистка компонентов принтера">
      Очистка компонентов принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e22059" title="Экономия энергии и бумаги">
      Экономия энергии и бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_ru" title="Перемещение принтера">
      Перемещение принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_ru" title="Транспортировка принтера">
      Транспортировка принтера
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ru" title="Поиск и устранение проблем">
     Поиск и устранение проблем
    </a>
   </p>
   <div id="divd0e22213">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_ru" title="Проблемы с качеством печати">
      Проблемы с качеством печати
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_ru" title="Коды ошибок принтера">
      Коды ошибок принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_ru" title="Проблемы с печатью">
      Проблемы с печатью
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ru" title="Принтер не отвечает">
      Принтер не отвечает
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ru" title="Не удается выполнить чтение флеш-накопителя">
      Не удается выполнить чтение флеш-накопителя
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ru" title="Активация порта USB">
      Активация порта USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_ru" title="Устранение замятий">
      Устранение замятий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e25884" title="Проблемы с сетевым подключением">
      Проблемы с сетевым подключением
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e26112" title="Проблемы с дополнительными аппаратными модулями">
      Проблемы с дополнительными аппаратными модулями
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e26260" title="Проблемы с расходными материалами">
      Проблемы с расходными материалами
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e26383" title="Проблемы с подачей бумаги">
      Проблемы с подачей бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e26749" title="Проблемы с передачей сообщений электронной почты">
      Проблемы с передачей сообщений электронной почты
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e26843" title="Проблемы с факсом">
      Проблемы с факсом
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e27488" title="Проблемы со сканированием">
      Проблемы со сканированием
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ru" title="Обращение в службу технической поддержки">
      Обращение в службу технической поддержки
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ru" title="Повторное использование и утилизация">
     Повторное использование и утилизация
    </a>
   </p>
   <div id="divd0e28267">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ru" title="Утилизация продуктов Lexmark">
      Утилизация продуктов Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ru" title="Утилизация упаковок Lexmark">
      Утилизация упаковок Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ru" title="Примечания">
     Примечания
    </a>
   </p>
   <div id="divd0e28304">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28307" title="Информация по продукту">
      Информация по продукту
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28324" title="Примечание о редакции">
      Примечание о редакции
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ru" title="Товарные знаки">
      Товарные знаки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ru" title="Уведомления о лицензировании">
      Уведомления о лицензировании
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ru" title="Уровни шума">
      Уровни шума
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_ru" title="Инструкция по обращению с отходами электрического и электронного оборудования (WEEE)">
      Инструкция по обращению с отходами электрического и электронного оборудования (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28430" title="Литий-ионный аккумулятор">
      Литий-ионный аккумулятор
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_ru" title="Регламент (ЕС) 2023/1542">
      Регламент (ЕС) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28468" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ru" title="Утилизация изделий">
      Утилизация изделий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ru" title="Возврат картриджей Lexmark для повторного использования или утилизации">
      Возврат картриджей Lexmark для повторного использования или утилизации
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ru" title="Предупреждение о чувствительности к разрядам статического электричества">
      Предупреждение о чувствительности к разрядам статического электричества
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ru" title="Программа ENERGY STAR">
      Программа ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ru" title="Информация о температуре">
      Информация о температуре
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ru" title="Уведомление о лазерном излучении">
      Уведомление о лазерном излучении
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ru" title="Потребляемая мощность">
      Потребляемая мощность
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_ru" title="Уведомления о соответствии стандартам для терминального телекоммуникационного оборудования">
      Уведомления о соответствии стандартам для терминального телекоммуникационного оборудования
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28732" title="Примечания о соответствии стандартам для беспроводных устройств">
      Примечания о соответствии стандартам для беспроводных устройств
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ru" title="Уведомление о модульном компоненте">
      Уведомление о модульном компоненте
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ru" title="Воздействие радиочастотного излучения">
      Воздействие радиочастотного излучения
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28757" title="Соответствие директивам Европейского сообщества (EC)">
      Соответствие директивам Европейского сообщества (EC)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_ru" title="Соответствие директивам Европейского сообщества (EC)">
      Соответствие директивам Европейского сообщества (EC)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_ru" title="Уведомление о радиопомехах">
      Уведомление о радиопомехах
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue